module.exports = __webpack_public_path__ + "static/media/chevron-up-blue-ic.eeedab52.svg";